import React, { useContext, useEffect, useRef } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useLocation } from "react-router-dom";
import { useTranslations } from "../../../../hooks/use-translations";
import { store } from "../../../Store";
import useIsMobile from "../../../../js/utilities/useIsMobile";
import { useNetworkStatus } from "../../../../hooks/use-network-status";
import { useAdvancedSearch } from "../../../../hooks/advanced-search/use-advanced-search";
import { useLanguage } from "../../../../hooks/use-language";

export const SearchBooksButton = () => {
	const lang = useLanguage();
	const textosInterfaz = useTranslations({ section: "header", lang: lang, array: true });
	const globalState = useContext(store);
	const { state } = globalState;


	const isLogged = state.sesionActiva !== null && state.sesionActiva === "SI";

	const location = useLocation();
	const isMobile = useIsMobile();
	const networkStatus = useNetworkStatus();

	const advancedSearch = useAdvancedSearch();
	const advancedSearchButtonRef = useRef(null);

	/*Asigna el botón que abre las opciones de búsqueda */
	const assignButton = () => {
		if (advancedSearchButtonRef.current) {
			globalState.dispatch({
				type: "CHANGE",
				path: "advancedSearch.triggerButton",
				value: advancedSearchButtonRef,
			});
		}
	}

	useEffect(() => {
		assignButton();
		window.addEventListener("resize", assignButton);
		document.body.addEventListener("resize", assignButton);
		return () => {
			window.addEventListener("resize", assignButton);
			document.body.addEventListener("resize", assignButton);
		};
	}, [advancedSearchButtonRef]);

	return (
		<>
			{!isMobile &&
				isLogged &&
				networkStatus.online &&
				!location.pathname.includes("/visor") &&
				state.cantidadLibros !== "NULL" &&
				state.cantidadLibros > 40 && (
					<div
						ref={advancedSearchButtonRef}
						className=" ml-3 d-flex align-items-center"
						onClick={() => {
							advancedSearch.setVisible(!advancedSearch?.state?.visible);
						}}
					>
						<button className="btn-libros primary-button-var2 py-2 px-3">
							<Icon icon="fa:search" className="mr-2" />
							{textosInterfaz?.buscar || "Libros"}
						</button>
					</div>


				)}
			{/* <li
						className={`btn-buscar mx-2 
							${
								isLogged &&
								!location.pathname.includes("/visor") &&
								state.cantidadLibros !== "NULL" &&
								state.cantidadLibros > 40
									? buscarOver
										? "btn-buscar"
										: "btn-buscar-general"
									: "btn-buscar"
							}
						`}
					>
						<button
							ref={advancedSearchButtonRef}
							className={`focusable-red d-flex align-items-center ${
								advancedSearch?.state?.visible && "activeMode"
							} font-weight-bold`}
							onClick={() => {
								advancedSearch.setVisible(!advancedSearch?.state?.visible);
							}}
							onMouseOver={() => setBuscarOver(true)}
							onMouseLeave={() => setBuscarOver(false)}
							style={{
								color:
									isLogged &&
									!location.pathname.includes("/visor") &&
									state.cantidadLibros !== "NULL" &&
									state.cantidadLibros > 40
										? buscarOver || advancedSearch?.state?.visible
											? ""
											: esTemaClasico
											? state.datosHeader?.colorLetra !== null
												? state.datosHeader?.colorLetra
												: "var(--onsecondary-color)"
											: "var(--primary-inverse)"
										: "",
								borderColor:
									isLogged &&
									!location.pathname.includes("/visor") &&
									state.cantidadLibros !== "NULL" &&
									state.cantidadLibros > 40
										? buscarOver || advancedSearch?.state?.visible
											? " var(--onprimary-inverse)"
											: esTemaClasico
											? state.datosHeader?.colorLetra !== null
												? state.datosHeader?.colorLetra
												: "var(--onsecondary-color)"
											: "var(--onprimary-color)"
										: "",
							}}
						>
							<i
								className="d-none d-xl-inline-block search-icon fas fa-search mr-2"
								aria-hidden="true"
							></i>{" "} *
							{textosInterfaz?.buscar || "Buscar"}
						</button>
					</li> */}
		</>
	);
};
